import { createAction, props } from '@ngrx/store';
import { UploadScreenInfo} from "src/app/shared/components/atoms/file-upload-component/model/file-uplaod.interface";
export const loadFile = createAction('[File] uploadFiles', props<{ uploadFileInfo: UploadScreenInfo }>());
export const resetFile = createAction('[File] resetFiles status inital');


